'use strict';

readMore.$inject = ['$templateCache'];
angular
    .module('tradersyard')
    .directive('readMode', readMore)
    .config([
        '$logProvider',
        function ($logProvider) {
            $logProvider.debugEnabled(false);
        },
    ]);

/** @ngInject */
function readMore($templateCache) {
    readModeController.$inject = ['$filter', '$scope', '$log'];
    var directive = {
        restrict: 'AE',
        scope: {
            hmText: '@',
            hmLimit: '@',
            hmMoreText: '@',
            hmLessText: '@',
            hmDotsClass: '@',
            hmLinkClass: '@',
        },
        template: $templateCache.get('readmore.template.html'),
        controller: readModeController,
        controllerAs: 'vm',
        bindToController: true,
    };

    return directive;

    /** @ngInject */
    // "bindToController: true" binds scope variables to Controller
    function readModeController($filter, $scope, $log) {
        var vm = this;
        vm.toggle = {
            dots: '...',
            dotsClass: vm.DotsClass,
            linkClass: vm.LinkClass,
        };

        // Toggle functions
        function setToggleMoreText() {
            $log.debug('setToggleMoreText');
            vm.toggle.moreText = vm.MoreText || 'Read more';
        }

        function setToggleLessText() {
            $log.debug('setToggleLessText');
            vm.toggle.lessText = vm.LessText || 'Read less';
        }

        function setCurrentToggleText() {
            $log.debug('setCurrentToggleText');
            vm.toggle.text = vm.toggle.state ? vm.toggle.lessText : vm.toggle.moreText;
        }

        function setShowToggle() {
            $log.debug('setShowToggle');
            vm.toggle.show = vm.moreText && vm.moreText.length > 0;
        }

        vm.doToggle = function () {
            $log.debug('doToggle');
            vm.toggle.state = !vm.toggle.state;
            vm.showMoreText = !vm.showMoreText;
            setCurrentToggleText();
        };

        $scope.$watch('vm.MoreText', function (newValue, oldValue) {
            if (newValue != oldValue) {
                $log.debug('hmMoreText changed');
                setToggleMoreText();
                setCurrentToggleText();
            }
        });

        $scope.$watch('vm.LessText', function (newValue, oldValue) {
            if (newValue != oldValue) {
                $log.debug('hmLessText changed');
                setToggleLessText();
                setCurrentToggleText();
            }
        });

        $scope.$watch('vm.DotsClass', function (newValue, oldValue) {
            if (newValue != oldValue) {
                $log.debug('hmDotsClass changed');
                vm.toggle.dotsClass = vm.DotsClass;
            }
        });

        $scope.$watch('vm.LinkClass', function (newValue, oldValue) {
            if (newValue != oldValue) {
                $log.debug('hmLinkClass changed');
                vm.toggle.linkClass = vm.LinkClass;
            }
        });

        // ----------

        // If negative number, set to undefined
        function validateLimit() {
            $log.debug('validateLimit');
            vm.Limit = vm.Limit && vm.Limit <= 0 ? undefined : vm.Limit;
        }

        function getMoreTextLimit() {
            $log.debug('getMoreTextLimit');
            return vm.Limit && vm.Limit < vm.Text.length ? vm.Limit - vm.Text.length : 0;
        }

        function setLessAndMoreText() {
            $log.debug('setLessAndMoreText');
            vm.lessText = $filter('limitTo')(vm.Text, vm.Limit);
            vm.moreText = $filter('limitTo')(vm.Text, getMoreTextLimit());
        }

        function initialize() {
            $log.debug('initialize');
            setToggleMoreText();
            setToggleLessText();
            validateLimit();
            setLessAndMoreText();
            setShowToggle();
            setCurrentToggleText();
        }

        initialize();

        $scope.$watch('vm.Text', function (newValue, oldValue) {
            if (newValue != oldValue) {
                $log.debug('hmText changed');
                validateLimit();
                setLessAndMoreText();
                setShowToggle();
            }
        });

        $scope.$watch('vm.Limit', function (newValue, oldValue) {
            if (newValue != oldValue) {
                $log.debug('hmLimit changed');
                validateLimit();
                setLessAndMoreText();
                setShowToggle();
            }
        });
    }
}

angular.module('tradersyard').run([
    '$templateCache',
    function ($templateCache) {
        $templateCache.put(
            'readmore.template.html',
            '<span name="text">\n	<span ng-bind-html="vm.lessText" style="white-space:pre-wrap;"></span>\n	<span ng-show="vm.showMoreText" class="more-show-hide" ng-bind-html="vm.moreText" style="white-space:pre-wrap;"></span>\n</span>\n\n<span name="toggle" ng-show="vm.toggle.show">\n	<span ng-class="vm.toggle.dotsClass" ng-show="!vm.toggle.state">{{ vm.toggle.dots }}</span>\n	<a ng-class="vm.toggle.linkClass" ng-click="vm.doToggle()">{{ vm.toggle.text }}</a>\n</span>\n'
        );
    },
]);
